
(function(){
  if(window.innerWidth>749)return;
  function fix(){
    var w=document.querySelector('.tabbed-collection__tabs-wrapper');
    var t=document.querySelector('.tabbed-collection__tabs');
    if(w)w.scrollLeft=0;
    if(t)t.scrollLeft=0;
  }
  fix();
  document.addEventListener('DOMContentLoaded',fix);
  window.addEventListener('load',function(){
    fix();
    setTimeout(fix,100);
    setTimeout(fix,300);
    setTimeout(fix,500);
    setTimeout(fix,1000);
    setTimeout(fix,2000);
  });
})();
